module.exports = __webpack_public_path__ + "images/icons_v2/eye-outlined-0af4f186.svg";